import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-biafit-primary">404</h1>
        <p className="mt-4 text-2xl font-semibold text-navy-700">
          Page Not Found
        </p>
        <p className="mt-2 text-lg text-gray-600">
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/admin/programs"
          className="mt-8 inline-flex items-center rounded-xl bg-biafit-primary px-6 py-3 text-base font-medium text-white transition duration-200 hover:bg-biafit-secondary"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
